module.exports = __webpack_public_path__ + "img/effects-17.5b41f75a.png";